import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

export const useSellMemberships = () => {
  const {
    isEnabled: isMembershipsSellingEnabled,
    isLoading: isMembershipsSellingLoading,
  } = useFeatureFlag(FEATURE_FLAGS.SELL_MEMBERSHIPS_ON_BOOKING_SITES);

  return {
    isMembershipsSellingEnabled,
    isMembershipsSellingLoading,
  };
};
